class CollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    if (!event.target.closest('[data-load-more-button]') || this.loading) return;
    this.loadMore();
  }

  loadMore() {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl || this.loading) return;

    this.loading = true;
    const button = this.querySelector('[data-load-more-button]');
    button?.setAttribute('aria-disabled', 'true');
    button?.classList.add('loading');

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productGrid = document.getElementById('product-grid');
        const newItems = html.querySelectorAll('#product-grid > .grid__item');

        if (productGrid && newItems.length) {
          newItems.forEach((item) => productGrid.appendChild(item));
        }

        const newLoadMore = html.querySelector('collection-load-more');
        if (newLoadMore) {
          this.syncFrom(newLoadMore);
        } else {
          this.dataset.nextUrl = '';
          this.classList.add('collection-load-more--complete');
          button?.remove();
        }

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(responseText);
        }
      })
      .catch(() => {
        button?.removeAttribute('aria-disabled');
        button?.classList.remove('loading');
      })
      .finally(() => {
        this.loading = false;
        if (this.dataset.nextUrl) {
          button?.removeAttribute('aria-disabled');
          button?.classList.remove('loading');
        }
      });
  }

  syncFrom(source) {
    this.dataset.nextUrl = source.dataset.nextUrl || '';
    this.dataset.viewed = source.dataset.viewed;
    this.dataset.total = source.dataset.total;
    this.dataset.progress = source.dataset.progress;

    const status = this.querySelector('[data-load-more-status]');
    const progress = this.querySelector('[data-load-more-progress]');

    if (status && source.querySelector('[data-load-more-status]')) {
      status.textContent = source.querySelector('[data-load-more-status]').textContent;
    }

    if (progress) {
      progress.style.width = `${this.dataset.progress}%`;
    }

    if (!this.dataset.nextUrl) {
      this.classList.add('collection-load-more--complete');
      this.querySelector('[data-load-more-button]')?.remove();
    }
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
